import Vue from 'vue'
import Vuex from 'vuex'
import sidebar from './modules/sidebar'
import AuthModule from './modules/Auth/AuthModule'
import MenuesModule from './modules/Menues/MenuesModule'
import SnackbarModalModule from './modules/SnackbarModal/SnackbarModalModule'
Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        sidebar,
        AuthModule,
        MenuesModule,
        SnackbarModalModule,
    },
    state: {},
    actions: {},
    getters: {},
})
